import React from "react";
import { Ban, Package, ShieldCheck } from "lucide-react";
import { joinClasses } from "./ResultsPrimitives.jsx";

const FLEET_TRUCK_STATUS_INDICATOR_ICON_CLASS_NAMES = {
  protected: "text-[rgba(15,92,87,0.72)]",
  "dispatch-disabled": "text-[rgba(185,28,28,0.78)]",
  "end-of-day-load-transit": "text-[rgba(185,28,28,0.9)]",
};

export default function FleetTruckStatusIndicator({
  className = "",
  isEndOfDayLoadTransit = false,
  style,
  title,
  variant,
}) {
  const isDispatchDisabled = variant === "dispatch-disabled";
  // Chargé PM multi-jours : camion chargé (colis), distinct du hors dispatch manuel (interdit).
  const isTransit = isDispatchDisabled && isEndOfDayLoadTransit;
  const Icon = isTransit ? Package : isDispatchDisabled ? Ban : ShieldCheck;
  const indicatorAttributes = isDispatchDisabled
    ? { "data-assignment-dispatch-disabled": true, "data-assignment-end-of-day-load-transit": isTransit || undefined }
    : { "data-assignment-truck-protection": true };

  return (
    <>
      <span
        {...indicatorAttributes}
        style={style}
        className={joinClasses([
          "inline-flex h-5 w-5 shrink-0 items-center justify-center",
          className,
        ])}
      >
        <Icon
          aria-hidden="true"
          className={joinClasses([
            "h-5 w-5",
            FLEET_TRUCK_STATUS_INDICATOR_ICON_CLASS_NAMES[isTransit ? "end-of-day-load-transit" : variant] || FLEET_TRUCK_STATUS_INDICATOR_ICON_CLASS_NAMES.protected,
          ])}
          strokeWidth={2.35}
        />
      </span>
      <span className="sr-only">{title}</span>
    </>
  );
}
